import { FILTER_TYPES, SORT_BY_RELEVANCE } from '../../../constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import UsageTracker from '../../../utils/UsageTracker';
import { Select } from 'foundations-components/components/Select';
import { FiltersWrapper } from './FiltersWrapper';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const getOptions = () => SORT_BY_RELEVANCE.map(sortBy => ({
  text: I18n.text(`academyComponents.topFilters.sortByRelevance.${sortBy}`),
  value: sortBy
}));
export const SortByRelevance = ({
  appearsIn
}) => {
  const [sortByValue, setSortBy] = useSearchParam(FILTER_TYPES.SORT_BY);
  const sortByRelevance = SORT_BY_RELEVANCE.includes(sortByValue[0]) ? sortByValue : [];
  const handleSortByRelevanceChange = value => {
    UsageTracker.trackStandalone('Filter Interaction', {
      action: value ? 'filter-selected' : 'filter-deselected',
      value,
      isDropdown: true,
      key: 'sort-by-relevance',
      appearsIn
    });
    setSortBy(value);
  };
  return /*#__PURE__*/_jsx(FiltersWrapper, {
    children: /*#__PURE__*/_jsx(Select, {
      clearable: true,
      menuInlineSize: 200,
      onSelectedOptionChange: evt => {
        handleSortByRelevanceChange(evt.value);
      },
      options: getOptions(),
      prefixWithSelectedItemsPlaceholder: true,
      selectedItemsPlaceholder: I18n.text('academyComponents.topFilters.sortByRelevance.filterTitle'),
      selectedValues: sortByRelevance
    })
  });
};